module.exports = __webpack_public_path__ + "static/media/Brugermanual_Mobilbase_01_2022.9d9e59f0.pdf";